import * as React from 'react';

import { HeatIndexModalContent } from '../../../components/HeatIndex';
import { useHeatIndexScale } from '../hooks';

export function HeatIndexModalContentContainer() {
  const intervals = useHeatIndexScale();

  return <HeatIndexModalContent intervals={intervals} />;
}
